import Modal from 'react-modal';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { IFileViewModel } from 'viewModels';
import { IListCustomContactsInputModel } from 'inputModels';
import { Container } from './styles';
import { Input } from '../../Inputs/Input';
import { Button } from '../../Buttons/Button';
import { DropZone } from '../../DropZone';
import { useAuth } from '../../../context';

interface ModalCreateListFavoritesProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

export function ModalCreateListFavorites({
  isOpen,
  onRequestClose,
}: ModalCreateListFavoritesProps) {
  const { user } = useAuth();
  //const { setListsContactsUser } = useContacts();
  const [pictureListContacts, setPictureListContacts] = useState<IFileViewModel>();
  const defaultValues: IListCustomContactsInputModel = {
    name: '',
  };

  const listContactSchema: yup.SchemaOf<IListCustomContactsInputModel> = yup.object().shape({
    name: yup.string().required('O campo nome é obrigatório'),
  });

  const {
    formState: { errors },
    control,
    reset,
    handleSubmit,
    setError,
  } = useForm({
    defaultValues,
    reValidateMode: 'onChange',
    resolver: yupResolver(listContactSchema),
  });

  const handleCreateListContact = async (data: IListCustomContactsInputModel) => {
    if (!data.name.trim()) {
      setError('name', { message: 'O campo nome não pode ser vazio' });
    } else {
      const formData = new FormData();
      formData.append('userId', user?.id);
      formData.append('name', data.name);
      if (pictureListContacts?.file) {
        formData.append('photo', pictureListContacts.file);
      }
      // ContactController.createListContact(formData).then((id) => {
      //   onRequestClose();
      //   reset(defaultValues);
      //   setPictureListContacts(undefined);
      //   const newListCustomContact: ICustomContactViewModel = {
      //     id,
      //     name: data.name,
      //     photo: {
      //       ...pictureListContacts,
      //       url: pictureListContacts?.file ? URL.createObjectURL(pictureListContacts.file) : undefined,
      //     },
      //     contacts: [],
      //   };
      //   setListsContactsUser((prev) => [...prev, newListCustomContact].sort((a, b) => a.name.localeCompare(b.name)));
      // });
    }
  };
  const handleRequestClose = () => {
    onRequestClose();
    reset(defaultValues);
    setPictureListContacts(undefined);
  };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-create-list-contacts">
      <Container hasImage={!pictureListContacts}>
        <div className="box-AddList">
          <div className="containerDropZone">
            <div className="contentDropZone">
              <DropZone
                type="attachments"
                renderType="button"
                iconButtonRender={<AddCircleOutlineIcon className="iconAdd" />}
                multipleFiles={false}
                onFile={(file) => setPictureListContacts(file)}
                onRemoveFile={() => setPictureListContacts(undefined)}
                renderSummary
                heightPictureSummury="4.5rem"
                widthPictureSummury="4.5rem"
              />
            </div>
            {!pictureListContacts && <p>Adicionar foto</p>}
          </div>
          <Input
            name="name"
            placeholder="Nome da lista"
            control={control}
            variant="standard"
            errorText={errors.name?.message}
            lengthInput={20}
          />
        </div>
        <div className="buttonModal">
          <Button
            text="Criar Lista"
            dimensions={{ width: '10rem', height: '2rem' }}
            font={{ size: '22', weight: 300 }}
            onClick={handleSubmit(handleCreateListContact)}
          />
        </div>
      </Container>
    </Modal>
  );
}
